// Copyright 2017-2019 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, isUndefined } from '@polkadot/util';

function sig(_ref) {
  var method = _ref.method,
      section = _ref.section;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return "".concat(section, ".").concat(method, "(").concat(args.join(', '), ")");
}

function doDoubleMap(creator, args) {
  var _creator$meta$type$as = creator.meta.type.asDoubleMap,
      key1 = _creator$meta$type$as.key1,
      key2 = _creator$meta$type$as.key2;
  assert(args.length === 2, "".concat(sig(creator, key1, key2), " is a doublemap, requiring 2 arguments, ").concat(args.length, " found")); // pass as tuple

  return [creator, args];
}

function doMap(creator, args) {
  var key = creator.meta.type.asMap.key;
  assert(args.length === 1, "".concat(sig(creator, key), " is a map, requiring 1 argument, ").concat(args.length, " found")); // expand

  return args.length ? [creator, args[0]] : [creator];
} // sets up the arguments in the form of [creator, args] ready to be used in a storage
// call. Additionally, it verifies that the correct number of arguments have been passed


export function extractStorageArgs(creator, _args) {
  var args = _args.filter(function (arg) {
    return !isUndefined(arg);
  });

  if (creator.meta.type.isDoubleMap) {
    return doDoubleMap(creator, args);
  } else if (creator.meta.type.isMap) {
    return doMap(creator, args);
  }

  assert(args.length === 0, "".concat(sig(creator), " does not take any arguments, ").concat(args.length, " found")); // no args

  return [creator];
}